"use client";

import React from "react";
import styles from "./Card.module.scss";
import Image from "next/image";

const Card = ({ title = "", description = "", icon = "" }) => {
  console.log("icon: ", icon);
  return (
    <div className={styles.card}>
      {(title || icon) && (
        <div className={styles.header}>
          {icon && (
            <div className={styles.iconWrapper}>
              <Image
                className={styles.icon}
                src={icon}
                alt="icon"
                width={50}
                height={50}
              />
            </div>
          )}

          {title && <h3 className={styles.title}>{title}</h3>}
        </div>
      )}
      {description && <p className={styles.description}>{description}</p>}
      {/* {children && <div className={styles.content}>{children}</div>} */}
      {/* {footer && <div className={styles.footer}>{footer}</div>} */}
    </div>
  );
};

export default Card;
